import React from "react";
import "./LoginModal.css";

const LoginModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null; // No mostrar nada si no está abierto

  return (
    <div className="login-modal-overlay">
      <div
        className="login-modal-expanding-circle"
        onAnimationEnd={() => document.querySelector(".login-modal-content").style.opacity = 1}
      ></div>
      <div className="login-modal-content">
        <button className="login-modal-close-btn" onClick={onClose}>
          ✕
        </button>
        <h2>Log in</h2>
        <form>
          <label>Username:</label>
          <input type="text" placeholder="Enter your username" />
          <label>Password:</label>
          <input type="password" placeholder="Enter your password" />
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default LoginModal;
